import { ComponentType } from 'react';

import TripPlannerChatConversationsPage from './TripPlannerChatConversationsPage';
import TripPlannerChatStatsPage from './TripPlannerChatStatsPage';

type TripPlannerChatTab = {
  path: string;
  title: string;
  component: ComponentType;
};

export const tripPlannerChatTabs: ReadonlyArray<TripPlannerChatTab> = [
  {
    path: '/trip-planner/chats',
    title: 'Chats',
    component: TripPlannerChatConversationsPage,
  },
  {
    path: '/trip-planner/chats/stats',
    title: 'Stats',
    component: TripPlannerChatStatsPage,
  },
];
